import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSessionStore } from '../hooks';
import type { SessionStore } from './sessionService';

const ProtectedRoute: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSessionStore((store: unknown) => (store as SessionStore).isAuthenticated);
  if (isAuthenticated === null) return null;
  if (!isAuthenticated) { navigate('/'); return null; }
  return <Outlet />;
};

export default ProtectedRoute;